import { fork, put, call, take } from 'redux-saga/effects';
import { REQUEST } from 'redux-config/reduxHelpers';
import { acceptError } from 'common/_redux';
import * as actionTypes from './actions';
import * as api from '../api';

export function* getAllConfigListSaga() {
  try {
    // api.getAllConfigList直接返回response.data，而非包含status和data的对象
    const responseData = yield call(api.getAllConfigList);
    console.log('API response data:', responseData);

    // 从responseData中提取detail数组，因为组件期望configList是数组类型
    const configListData = responseData && responseData.detail ? responseData.detail : [];
    yield put(actionTypes.getAllConfigList.success(configListData));
  } catch (e) {
    // 确保传递字符串错误信息，而不是错误对象
    const errorMessage = e.message || '获取配置列表失败';
    yield put(acceptError(errorMessage, true));
    yield put(actionTypes.getAllConfigList.failure());
  }
}

export function* getAllConfigListWatcherSaga() {
  while (true) {
    yield take(actionTypes.GET_ALL_CONFIG_LIST[REQUEST]);
    yield call(getAllConfigListSaga);
  }
}

const watchers = [fork(getAllConfigListWatcherSaga)];

export default watchers;
